import { post2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { RestaurantMap } from "@/shared/utils/interfaces";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const useRestaurantMapMutation = () => {
  const queryClient = useQueryClient();
  const branchId = useBranchId();
  const { t } = useTranslation("");
  const mutation = useMutation({
    onSuccess: () => {
      toast.success(t("success.create"));
      queryClient.refetchQueries({
        queryKey: ["restaurantMap", branchId],
        exact: true,
      });
    },
    mutationFn: (restaurant: RestaurantMap) =>
      post2(`/internal/secure/pos/v1/restaurant/map/${branchId}`, restaurant),
  });
  return mutation;
};

export default useRestaurantMapMutation;
